import { ArrowRightOnRectangleIcon, BuildingOffice2Icon, CloudIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import MandantenTab from '../components/admin/MandantenTab';
import CloudAnbindungen from '../components/admin/CloudAnbindungen';

const TABS = [
  { id: 'mandanten', titel: 'Mandanten', Icon: BuildingOffice2Icon },
  { id: 'anbindungen', titel: 'Cloud-Anbindungen', Icon: CloudIcon },
] as const;
type Tab = typeof TABS[number]['id'];

/**
 * Betreiber-Konsole von powerCOMPANY (Host admin.*) — Christian 08.09.: „demo und admin gehören auf keinen Fall
 * zusammen … das muss strikt getrennt werden." Diese Seite laeuft OHNE Mandantenkontext: kein
 * Firmen-Arbeitsplatz, keine Dateien — nur Mandanten anlegen und einrichten. Anmeldung
 * ueber PowerID, Gruppe powercompany-admin (Betreiber), nicht ueber Firmen-Konten.
 */
export default function BetreiberKonsole() {
  const { user, logout } = useAuth();
  const [toast, setToast] = useState<{ msg: string; variant: 'ok' | 'err' } | null>(null);
  const [tab, setTab] = useState<Tab>(() => (window.location.hash === '#anbindungen' ? 'anbindungen' : 'mandanten'));
  const wechseln = (t: Tab) => { setTab(t); window.history.replaceState(null, '', t === 'mandanten' ? window.location.pathname : `#${t}`); };
  const flash = (msg: string, variant: 'ok' | 'err' = 'ok') => { setToast({ msg, variant }); setTimeout(() => setToast(null), 3200); };
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="flex h-14 items-center justify-between gap-3 bg-ps-dark-900 px-4 text-white sm:px-5">
        <div className="flex min-w-0 items-center gap-2">
          <BuildingOffice2Icon className="h-5 w-5 shrink-0 text-primary-300" />
          <span className="font-semibold">powerCOMPANY</span>
          <span className="hidden text-sm text-ps-dark-300 sm:inline">Betreiber-Konsole</span>
        </div>
        <div className="flex shrink-0 items-center gap-3 text-sm">
          <span className="hidden text-ps-dark-200 sm:inline">{user?.name || user?.username}</span>
          <button onClick={() => void logout()} className="flex items-center gap-1 rounded-md bg-ps-dark-800 px-2.5 py-1.5 text-xs hover:bg-ps-dark-700"><ArrowRightOnRectangleIcon className="h-4 w-4" /> Abmelden</button>
        </div>
      </header>
      <main className="mx-auto max-w-[1920px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          Betreiber-Sicht: Hier werden Mandanten (Firmen) angelegt und eingerichtet und die Cloud-Anbindungen für alle Firmen freigeschaltet. Daten der Mandanten sind hier nicht erreichbar — dafür meldet man sich auf der Adresse der jeweiligen Firma an.
        </div>
        <nav className="mb-4 flex gap-1 border-b border-gray-200" aria-label="Bereiche">
          {TABS.map(({ id, titel, Icon }) => (
            <button key={id} onClick={() => wechseln(id)} aria-current={tab === id ? 'page' : undefined}
              className={`-mb-px flex items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium ${tab === id ? 'border-primary-500 text-primary-700' : 'border-transparent text-ps-dark-500 hover:text-ps-dark-800'}`}>
              <Icon className="h-4 w-4" /> {titel}
            </button>
          ))}
        </nav>
        {tab === 'mandanten' ? <MandantenTab flash={flash} /> : <CloudAnbindungen flash={flash} />}
      </main>
      {toast && <div className={`fixed bottom-6 right-6 z-40 rounded-md border px-4 py-3 text-[13px] shadow-md ${toast.variant === 'ok' ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : 'border-rose-200 bg-rose-50 text-rose-700'}`}>{toast.msg}</div>}
    </div>
  );
}
